<template>
  <div class="transaction-info-entry">
    <component
      :is="component"
      ref="componentRef"
      :instance
      :index
      :title
      :account="isAccountExists"
      :amount="isAmountExists"
      :asset="isAssetExists"
      @edit="handleEdit"
    >
      <template v-if="$slots.label" #label>
        <slot name="label" />
      </template>
      <template v-if="$slots.account" #account>
        <slot name="account" />
      </template>
      <template v-if="$slots.amount" #amount>
        <slot name="amount" />
      </template>
      <template v-if="$slots.asset" #asset>
        <slot name="asset" />
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { TransactionClass } from '@types'

import { TRANSACTION_FIELD } from '@/const'

import { useTransactionsSettingsStore } from '@/store/transactions/settings'

import EntryDefault from './EntryDefault.vue'

type Props = {
  instance?: TransactionClass
  index: number
}

type Emits = {
  edit: [string]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

defineOptions({
  components: {
    EntryDefault,
  },
})

defineExpose({
  reset: (field?: string) => {
    componentRef.value?.reset(field)
  },
})

const transactionsSettingsStore = useTransactionsSettingsStore()

const componentRef = useTemplateRef<any>('componentRef')

const settings = computed(
  () =>
    props.instance &&
    transactionsSettingsStore?.getList.find(
      item =>
        item.name ===
        props.instance?.field<string>(TRANSACTION_FIELD.TYPE).value,
    )?.entries?.[props.index - 1],
)

const title = computed(() => settings.value?.title)

const component = computed(() => {
  return 'EntryDefault'
})

const isAccountExists = computed(() => !!settings.value?.account)

const isAmountExists = computed(() => !!settings.value?.amount)

const isAssetExists = computed(() => !!settings.value?.asset)

const handleEdit = (field: string) => {
  emit('edit', field)
}
</script>

<style>
.transaction-info-entry {
  @apply bg-body-gray;
  @apply py-1.5 px-2;
  @apply rounded-md;
  @apply overflow-hidden;
}
</style>
